module.exports = __webpack_public_path__ + "img/trainingsschema-week-1-4.d8b8f4b3.png";